export default "__VITE_ASSET__CCb1ECrW__"